import React from 'react';
import ReactDOM from 'react-dom/client'; // Importing from 'react-dom/client'
import ReactGA from "react-ga4";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { persistor, store } from './store';

ReactGA.initialize("G-G1V75GJMEW"); // Replace with your GA4 Measurement ID

// React 18 uses createRoot instead of render
const root = ReactDOM.createRoot(document.getElementById('root'));
document.body.style.margin = '0';
document.body.style.padding = '0';
document.documentElement.style.margin = '0';
document.documentElement.style.padding = '0';
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
